import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Name',
    value: 'name',
  },

  {
    label: 'Display name',
    value: 'displayName',
  },
  {
    label: 'Logo',
    value: 'avatar',
  },

  {
    action: ['edit', 'toggle'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
